import React from "react";

const formatTimestamp = (value) => {
  if (!value) return "just now";
  const date = value.toDate ? value.toDate() : new Date(value);
  return Number.isNaN(date.getTime()) ? "just now" : date.toLocaleString();
};

function AgentCard({ agent, onEdit }) {
  const updatedLabel = formatTimestamp(agent.updatedAt || agent.createdAt);
  const description = agent.description || "No description provided.";
  const badgeLabel = agent.method || agent.httpMethod || "Agent";

  return (
    <div className="card">
      <div className="flex-between">
        <h4 className="card__title">{agent.name || "Untitled Agent"}</h4>
        <div className="badge">{badgeLabel}</div>
      </div>
      <div className="card__meta">Updated {updatedLabel}</div>
      <p className="muted">{description}</p>
      {agent.swaggerUrl && (
        <p className="card__meta" style={{ marginTop: "8px" }}>
          Swagger: <a href={agent.swaggerUrl}>{agent.swaggerUrl}</a>
        </p>
      )}
      {onEdit && (
        <div className="card__actions" style={{ marginTop: "12px" }}>
          <button className="button small" onClick={() => onEdit(agent.id)}>
            Edit
          </button>
        </div>
      )}
    </div>
  );
}

export default AgentCard;
